export const rules = {
  username: [
    { required: true, message: '請輸入空英會員帳號', trigger: 'blur' },
    { type: 'email', message: '請輸入正確的 email', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '請輸入密碼', trigger: 'blur' }
  ]
}